var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4994 0C9.8266 0 0 9.28662 0 21.8244C0 28.383 2.68868 34.0528 7.06481 37.9677C7.43042 38.2939 7.65542 38.7552 7.66666 39.2502L7.79041 43.2551C7.79942 43.5497 7.88068 43.8377 8.02703 44.0936C8.17338 44.3495 8.38036 44.5656 8.62976 44.7228C8.87917 44.88 9.16337 44.9735 9.45738 44.9951C9.7514 45.0168 10.0462 44.9659 10.316 44.8469L14.7821 42.8782C15.159 42.7095 15.5864 42.6813 15.9858 42.7882C18.0389 43.3507 20.2213 43.6544 22.4994 43.6544C35.1722 43.6544 44.9988 34.3678 44.9988 21.83C44.9988 9.29225 35.1722 0 22.4994 0Z",
    fill: "url(#paint0_radial_6223_365953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.98875 28.2086L15.5979 17.7239C15.8466 17.3292 16.1743 16.9902 16.5606 16.7286C16.9468 16.4669 17.383 16.2881 17.8418 16.2035C18.3006 16.119 18.7719 16.1304 19.2261 16.2372C19.6802 16.344 20.1073 16.5438 20.4803 16.8239L25.7395 20.7669C25.9743 20.9427 26.26 21.0373 26.5533 21.0362C26.8466 21.0352 27.1316 20.9387 27.3651 20.7613L34.4637 15.3727C35.4086 14.6527 36.6461 15.789 36.0161 16.7958L29.4013 27.2749C29.1527 27.6696 28.8249 28.0085 28.4387 28.2702C28.0525 28.5319 27.6162 28.7107 27.1574 28.7952C26.6986 28.8798 26.2273 28.8683 25.7732 28.7616C25.319 28.6548 24.892 28.455 24.5189 28.1749L19.2597 24.2318C19.0249 24.0561 18.7393 23.9615 18.446 23.9625C18.1527 23.9636 17.8677 24.0601 17.6341 24.2375L10.5356 29.6261C9.59061 30.3461 8.35314 29.2155 8.98875 28.2086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6223_365953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.53729 44.9988) scale(49.4986 49.4986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.9b0b3cfcdaedde884e63a39e5b5e7f32.svg";
export { ForwardRef as ReactComponent };